/* Mimeeq tekstu tabula – viens fails der visiem trim veikaliem.
   Valodu ņemam no Shopify.locale, jo tēmās html lang mēdz būt nepareizs. */
const MMQ_T = (() => {
	const val = ((window.Shopify && Shopify.locale) || document.documentElement.lang || "lv").slice(0, 2).toLowerCase();
	const v = {
		lv: { ielade: "Ielādējam 3D skatu…", velc: "Velc, lai apskatītu no visām pusēm",
		      izvietojums: "Izvietojums:", kreisa: "Kreisajā pusē", laba: "Labajā pusē" },
		lt: { ielade: "Įkeliame 3D vaizdą…", velc: "Vilkite, kad apžiūrėtumėte iš visų pusių",
		      izvietojums: "Vieta:", kreisa: "Kairėje", laba: "Dešinėje" },
		et: { ielade: "Laadime 3D-vaadet…", velc: "Lohista, et vaadata igast küljest",
		      izvietojums: "Asukoht:", kreisa: "Vasakul", laba: "Paremal" },
	};
	return v[val] || v.lv;
})();

/* Mimeeq: izvēles, kas veiktas pirms konfiguratora ielādes, tiek uzkrātas
   un nosūtītas, tiklīdz modelis ir gatavs. */
const mmqPending = new Map();
let mmqReady = false;
let mmqValidCodes = null; // blockName -> Set(kodi); nesūtām kodus, kuru modelī nav

function mmqMark(block, code) {
	if (!block || !code) return;
	mmqPending.set(block, code);
	if (mmqReady) mmqFlush();
}

function mmqCodeExists(block, code) {
	if (!mmqValidCodes) return true;
	const set = mmqValidCodes.get(block);
	if (!set || !set.size) return true; // nav datu par bloku – nefiltrējam
	return set.has(code);
}

function mmqFlush() {
	if (!mmqPending.size) return;
	const entries = Array.from(mmqPending);
	mmqPending.clear();
	entries.reduce(
		(chain, [block, code]) =>
			chain.then(() => {
				if (!mmqCodeExists(block, code)) {
					// "NO..." kodi nozīmē noņemšanu – ja modelī kods atšķiras, atrodam tā None opciju
					const set = mmqValidCodes && mmqValidCodes.get(block);
					const alt =
						set && code.indexOf("NO") === 0
							? Array.from(set).find((c) => c.indexOf("NO") === 0)
							: null;
					if (!alt) {
						console.warn("Mimeeq: koda nav modelī, izlaižam", block, code);
						return;
					}
					code = alt;
				}
				return window.mimeeqApp.actions
					.markOptionByBlockNameAndOptionCode(block, code)
					.catch((err) => console.error("Mimeeq error:", block, code, err));
			}),
		Promise.resolve()
	);
}

function mmqSyncPageState() {
	document
		.querySelectorAll("input[data-mmq-block]:checked, option[data-mmq-block]:checked")
		.forEach((el) => {
			// papildaprīkojuma kartītes izvēles sūtām tikai tad, ja pats aprīkojums ir atzīmēts
			const card = el.closest(".addon-product-card");
			if (card) {
				const cb = card.querySelector(".addon-checkbox input[type='checkbox']");
				if (!cb || !cb.checked) return;
			}
			if (el.dataset.mmqCode) mmqPending.set(el.dataset.mmqBlock, el.dataset.mmqCode);
		});
	document
		.querySelectorAll(".addon-checkbox input[type='checkbox'][data-main-mmq-block]")
		.forEach((cb) => {
			const code = cb.checked
				? mmqShowCodeForCard(cb)
				: cb.dataset.mainMmqCodeHide;
			if (code) mmqPending.set(cb.dataset.mainMmqBlock, code);
		});
}

function mmqWatchApp() {
	if (!document.querySelector("mmq-embed")) return;
	let waited = 0;
	const timer = setInterval(() => {
		waited += 300;
		const blocks = window.mimeeqApp?.observers?.optionSets?.blocks;
		if (blocks) {
			clearInterval(timer);
			let osdCache = null;
			let blockList = null;
			const rebuildMap = () => {
				if (!blockList || !blockList.length || !osdCache) return;
				const map = new Map();
				blockList.forEach((b) => {
					const codes = new Set();
					(b.optionSetIds || []).forEach((id) => {
						const os = osdCache[id];
						(os && os.options ? os.options : []).forEach(
							(o) => o.code && codes.add(o.code)
						);
					});
					if (b.blockName) map.set(b.blockName, codes);
					if (b.name) map.set(b.name, codes);
				});
				mmqValidCodes = map;
			};
			const tryStart = () => {
				rebuildMap();
				if (mmqReady || !blockList || !blockList.length) return;
				mmqReady = true;
				mmqInjectPlacements(); // šobrīd tikai bezvadu lādētājam (skat. MMQ_PLACEMENTS)
				mmqSyncPageState();
				mmqFlush();
				// modeļa noklusējumi var ielādēties vēlāk un pārrakstīt izvēles –
				// pāris reizes apliecinām lapas stāvokli vēlreiz
				[3000, 7000, 12000].forEach((ms) =>
					setTimeout(() => {
						mmqSyncPageState();
						mmqFlush();
					}, ms)
				);
			};
			window.mimeeqApp.observers.optionSets.optionSetsData.subscribe((ev) => {
				osdCache = (ev && ev.newValue) || osdCache;
				tryStart();
			});
			blocks.subscribe((event) => {
				blockList = (event && event.newValue) || event || blockList;
				tryStart();
			});
		} else if (waited >= 12000) {
			clearInterval(timer);
			// Mimeeq CDN reizēm atbild 429 un embeds klusi apstājas bez atkārtošanas.
			// Konfigam normāli jāatnāk ~2 s laikā; ja pēc 12 s mimeeqApp nav vispār,
			// ielāde ir mirusi – pārsākam, izveidojot embed elementu no jauna (līdz 2x).
			const embed = document.querySelector("mmq-embed");
			window.__mmqRestarti = window.__mmqRestarti || 0;
			if (embed && window.__mmqRestarti < 2 && typeof window.mimeeqApp === "undefined") {
				window.__mmqRestarti++;
				console.warn("Mimeeq neielādējās 12 sekundēs – restartējam embedu (" + window.__mmqRestarti + ")");
				const fresh = embed.cloneNode(false);
				fresh.classList.remove("hydrated");
				embed.replaceWith(fresh);
				mmqWatchApp();
			} else {
				console.warn("Mimeeq neielādējās; restarti: " + window.__mmqRestarti);
			}
		}
	}, 300);
}

// Izvietojuma izvēle (kreisā/labā puse) papildaprīkojumam, kam modelis to atbalsta
const MMQ_PLACEMENTS = {
	WirelessCharger: { block: "WirelessCharger", opts: [["WCL", MMQ_T.kreisa], ["WCP", MMQ_T.laba]] },
	// CABLETUBE un CableManagement izvietojums – ieslēgt pēc saskaņošanas:
	// CABLETUBE: { block: "CableTubePlacement", opts: [["L", MMQ_T.kreisa], ["R", MMQ_T.laba]] },
	// CableManagement: { block: "CableManagement", opts: [["CML", MMQ_T.kreisa], ["CMP", MMQ_T.laba]] },
};

// Stūra izvēle Shopify varianta opcijā -> Mimeeq kods. Modeļos kodi atšķiras
// (Flow lieto CMR, pārējie CMP), tāpēc katrai pusei ir vairāki kandidāti un
// ņemam pirmo, kas konkrētajā modelī tiešām ir. Ja neviena nav vai stūris
// nesakrīt ne ar vienu paraugu, paliek kartītes noklusējuma kods.
const MMQ_SELECT_CODES = {
	// varianta vērtība -> Mimeeq kods. Vārdi visās trijās valodās, jo viens
	// fails strādā LV, LT un EE veikalā (kreisais / kairė / vasak).
	CableManagement: [
		[/kreis|kair|vasak/i, ["CML"]],
		[/lab|de[sš]in|parem/i, ["CMP", "CMR"]],
	],
	// LT lādētājam stūris ir varianta opcija, ne injicētie radio
	WirelessCharger: [
		[/kreis|kair|vasak/i, ["WCL"]],
		[/lab|de[sš]in|parem/i, ["WCP"]],
	],
};

function mmqShowCodeForCard(cb) {
	const fallback = cb.dataset.mainMmqCodeShow;
	const block = cb.dataset.mainMmqBlock;
	const map = MMQ_SELECT_CODES[block];
	if (!map) return fallback;
	const card = cb.closest(".addon-product-card");
	const select =
		card && card.querySelector("select.addon-option-select, input.addon-option-select:checked");
	if (!select) return fallback;
	const hit = map.find(([re]) => re.test(select.value));
	if (!hit) return fallback;
	return hit[1].find((code) => mmqCodeExists(block, code)) || fallback;
}

function mmqInjectPlacements() {
	if (document.getElementById("mmq-placement-style")) return;
	const style = document.createElement("style");
	style.id = "mmq-placement-style";
	style.textContent =
		".mmq-placement{display:none;gap:15px;align-items:center;margin:0 0 15px;font-size:14px}" +
		".addon-product-card.active .mmq-placement{display:flex}" +
		".mmq-placement label{display:flex;align-items:center;gap:5px;cursor:pointer}" +
		".mmq-placement input{accent-color:#000}";
	document.head.appendChild(style);

	document
		.querySelectorAll(".addon-checkbox input[type='checkbox'][data-main-mmq-block]")
		.forEach(function (cb, i) {
			const conf = MMQ_PLACEMENTS[cb.dataset.mainMmqBlock];
			if (!conf) return;
			const avail = conf.opts.filter(([code]) => mmqCodeExists(conf.block, code));
			if (avail.length < 2) return; // modelī izvēles nav – neko nerādām
			const card = cb.closest(".addon-product-card");
			if (!card || card.querySelector(".mmq-placement")) return;
			const wrap = document.createElement("div");
			wrap.className = "mmq-placement";
			const groupName = "mmq-placement-" + i;
			const defCode = avail.some(([c]) => c === cb.dataset.mainMmqCodeShow)
				? cb.dataset.mainMmqCodeShow
				: avail[0][0];
			wrap.innerHTML =
				// tulkojums MMQ_T bija, bet virsraksts palika latviski — LT/EE klients
				// papildaprīkojuma kartītē redzēja "Izvietojums:" (nomērīts 02.09.)
				'<span class="mmq-placement__title">' + MMQ_T.izvietojums + "</span>" +
				avail
					.map(
						([code, label]) =>
							'<label><input type="radio" name="' + groupName + '" value="' + code +
							'" data-mmq-block="' + conf.block + '" data-mmq-code="' + code + '"' +
							(code === defCode ? " checked" : "") + ">" + label + "</label>"
					)
					.join("");
			const info = card.querySelector(".addon-info") || card;
			const before = info.querySelector(".addon-more");
			info.insertBefore(wrap, before || null);
			// ja aprīkojums ieslēgts caur bloka kodu (piem., WirelessCharger), izvēlētais kods aizstāj show kodu
			wrap.addEventListener("change", function (ev) {
				const input = ev.target;
				if (cb.checked && input.dataset.mmqCode) {
					mmqMark(input.dataset.mmqBlock, input.dataset.mmqCode);
				}
			});
		});
}

// Ja 3D canvas inicializējies paslēptā slaidā, tas paliek 1×1 – resize to pamodina
function mmqWakeCanvas() {
	const slide = document.querySelector(".product-3d-window");
	let overlay = null;
	if (slide && !slide.querySelector(".mmq-loading")) {
		const style = document.createElement("style");
		style.textContent =
			".product-3d-window{position:relative}" +
			// Izmēru CSS embedam šeit NAV apzināti (kā LV): Mimeeq pats taisa kvadrātisku audeklu
			// pēc slaida platuma (LV nomērīts 02.09.: audekls 882x882, buferis 1764x1764, slaids
			// 902). Piespiests aspect-ratio 2:1 deva puskvadrātu ar tukšām joslām.
			// Kamēr modelis tikai iet gatavs (initialized mēdz nākt 10 s pēc audekla), pārklājs
			// kļūst caurspīdīgs – klients redz modeli parādāmies, nevis pelēku lauku.
			".mmq-loading.is-soft{background:rgba(238,237,234,.35)}" +
			// Tēma slaida bērniem uzspiež position:relative UN
			// `.product__media-item > :not(.product__xr-button){display:block}`
			// (section-main-product.css, svars 0-2-0) — tas uzvarēja pār `.mmq-loading`,
			// tāpēc pārklājs bija bloks un ritenītis ar tekstu stāvēja augšējā kreisajā
			// stūrī virs modeļa, nevis centrā. Šis selektors (0-3-0) to pārsit.
			".product__media-item.product-3d-window > .mmq-loading{position:absolute;inset:0;" +
			"display:flex;flex-direction:column;gap:14px;align-items:center;justify-content:center}" +
			".mmq-loading{position:absolute;inset:0;display:flex;flex-direction:column;gap:14px;align-items:center;justify-content:center;background:#eeedea;z-index:2;transition:opacity 250ms ease-out;pointer-events:none}" +
			".mmq-loading.is-done{opacity:0}" +
			".mmq-loading__ring{width:34px;height:34px;border-radius:50%;border:3px solid #d8d7d3;border-top-color:#111;animation:mmq-spin .6s linear infinite}" +
			".mmq-loading__text{font-size:14px;color:#555}" +
			"@keyframes mmq-spin{to{transform:rotate(360deg)}}" +
			"@media (prefers-reduced-motion: reduce){.mmq-loading__ring{animation-duration:1.4s}}";
		document.head.appendChild(style);
		overlay = document.createElement("div");
		overlay.className = "mmq-loading";
		overlay.innerHTML =
			'<div class="mmq-loading__ring"></div><div class="mmq-loading__text">' + MMQ_T.ielade + '</div>';
		slide.appendChild(overlay);
	}
	const removeOverlay = () => {
		if (!overlay) return;
		const el = overlay;
		el.classList.add("is-done");
		setTimeout(() => el.remove(), 350);
		overlay = null;
	};
	// Indikatoru noņemam tikai tad, kad 3D tiešām sāk zīmēties. Modelis stāv miera
	// stāvoklī, kamēr 3D slaids nav aktīvs: audekla atribūts paliek noklusējuma
	// 300x150, kaut arī kastītei ir izmērs. Tāpēc pārbaudām divas lietas – vai
	// slaids ir aktīvs un vai audeklam ir īstais izmērs (kastītes izmērs reiz
	// ekrāna blīvumu). Tikai notikums "initialized" atnāk krietni par agru.
	let inited = false;
	document.addEventListener("mimeeq-3d-product-initialized", () => { inited = true; }, {
		once: true,
	});
	const slaidsAktivs = () => {
		if (!slide) return false;
		if (slide.classList.contains("swiper-slide")) {
			return slide.classList.contains("swiper-slide-active");
		}
		return slide.getBoundingClientRect().width > 50;
	};
	let ticks = 0;
	const t = setInterval(() => {
		const embed = document.querySelector("mmq-embed");
		// mmq-embed DOM parādās vēlāk nekā DOMContentLoaded, tāpēc tā trūkums
		// nav iemesls padoties – citādi indikators pazūd jau pirmajā pārbaudē
		// un klients redz tukšu lodziņu bez nekā.
		if (!embed) return;
		// laiku skaitām tikai tad, kad slaids ir atvērts; kamēr klients pie 3D nav
		// ticis, indikatoram nav jēgas pazust
		if (!slaidsAktivs()) return;
		ticks++;
		if (ticks > 90) {
			removeOverlay();
			return clearInterval(t);
		}
		const canvas = embed.querySelector("canvas");
		if (!canvas) return;
		// Mērķis ir SLAIDA platums, nevis embeda pašreizējais. Embeds pēc klikšķa mēdz būt
		// šaurāks par slaidu (02.09. LT: 381 no 642) un izaug tikai pēc dzinēja pārmērīšanas.
		// Pret sevi pašu tāds audekls "sakrīt", tāpēc pārklājs kļuva caurspīdīgs jau pirms
		// izauguma – tieši to klients redzēja kā "mazs logs, tad ielādējas lielāks".
		const merkis = slide ? slide.getBoundingClientRect().width : 0;
		const cv = canvas.getBoundingClientRect();
		const dpr = window.devicePixelRatio || 1;
		if (cv.width < merkis * 0.9 || canvas.width < cv.width * dpr * 0.7) {
			// audeklam vēl nav īstā izmēra – pamodinām un turam pārklāju necaurspīdīgu
			window.dispatchEvent(new Event("resize"));
			// ja pēc ~6 s dzinējs joprojām nav izaudzis, labāk rādīt modeli caur puscaurspīdīgu
			// pārklāju nekā turēt pelēku lauku
			if (ticks > 8 && overlay) overlay.classList.add("is-soft");
			return;
		}
		// audekls ir īstajā izmērā – no šī brīža pārklājs vairs nedrīkst būt necaurspīdīgs
		if (overlay) overlay.classList.add("is-soft");
		if (inited) {
			// pirmais kadrs uzzīmējas mirkli pēc izmēra
			setTimeout(removeOverlay, 400);
			clearInterval(t);
		}
	}, 700);
}

// Kopsumma pogā "Pievienot grozam" (galds + atzīmētais papildaprīkojums) × daudzums
function mmqParsePrice(text) {
  const value = (text || "").replace(/[\s\u00a0\u202f]/g, "");
  const match = value.match(/€([0-9][0-9.,]*)/) || value.match(/([0-9][0-9.,]*)€/);
  if (!match) return null;
  const amount = match[1];
  const decimal = amount.match(/[.,](\d{2})$/);
  const whole = decimal ? amount.slice(0, -3) : amount;
  if (!/^\d+(?:[.,]\d{3})*$/.test(whole)) return null;
  return Number(whole.replace(/[.,]/g, "")) + (decimal ? Number(decimal[1]) / 100 : 0);
}

// Kopsummu rakstām tā, kā veikals pats raksta cenas: LV skaitlis+€, LT/EE €+skaitlis.
function mmqFormatPrice(summa, paraugs) {
	const skaitlis = summa.toFixed(2).replace(".", ",");
	return /^\s*€/.test(paraugs || "") ? "€" + skaitlis : skaitlis + "€";
}

function mmqUpdateCartSum() {
	const btn = document.querySelector(".product-form__submit");
	const wrap = document.querySelector(".addon-products-wrapper");
	if (!btn || !wrap || btn.disabled) return;
	const span = btn.querySelector("span");
	if (!span) return;
	if (!span.dataset.baseLabel) span.dataset.baseLabel = span.textContent.trim();

	const visible = (el) => el && el.offsetParent !== null;
	let main = null;
	let cenasParaugs = "";
	document.querySelectorAll(".price-item--sale, .price-item--regular").forEach((el) => {
		if (main !== null || !visible(el)) return;
		const p = mmqParsePrice(el.textContent);
		if (p === null) return;
		main = p;
		cenasParaugs = el.textContent.replace(/\s/g, "");
	});
	if (main === null) return;

	const helper = [...document.querySelectorAll(".tax-price-helper")].find(visible);
	const arPVN = helper ? /ar PVN/i.test(helper.textContent) : false;

	let addons = 0;
	document
		.querySelectorAll(".addon-checkbox input[type='checkbox']:checked")
		.forEach((cb) => {
			const card = cb.closest(".addon-product-card");
			const p = card && mmqParsePrice((card.querySelector(".addon-price") || {}).textContent);
			if (p) addons += arPVN ? p * 1.21 : p;
		});

	const qtyEl = document.querySelector('input[name="quantity"]');
	const qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
	const total = (main + addons) * qty;
	span.textContent = span.dataset.baseLabel + " – " + mmqFormatPrice(total, cenasParaugs);
}

function mmqWatchCartSum() {
	if (!document.querySelector(".addon-products-wrapper")) return;
	mmqUpdateCartSum();
	document.addEventListener("change", () => setTimeout(mmqUpdateCartSum, 50));
	document.addEventListener("click", (ev) => {
		if (ev.target.closest("[class*='vat-switcher'], .quantity__button"))
			setTimeout(mmqUpdateCartSum, 150);
	});
	const priceBox = document.querySelector(".price");
	if (priceBox)
		new MutationObserver(() => mmqUpdateCartSum()).observe(priceBox, {
			subtree: true,
			childList: true,
			characterData: true,
		});
}

// Candyrack piedāvājumus, kas dublē papildaprīkojuma kartītes, paslēpjam.
// Candyrack savu bloku pārzīmē vairākkārt, tāpēc slēpšana jāatkārto ar novērotāju.
function mmqHideCandyrackDuplicates() {
	if (!document.querySelector(".addon-products-wrapper")) return;
	const norm = (t) => (t || "").toLowerCase().replace(/\s+/g, " ").trim().slice(0, 40);
	const addonTitles = [...document.querySelectorAll(".addon-title")].map((e) =>
		norm(e.textContent)
	);
	if (!addonTitles.length) return;

	const scan = () => {
		document
			.querySelectorAll("[class*='candyrack-ppp-offer-id'] a[class*='offerProductTitle']")
			.forEach((a) => {
				if (addonTitles.some((x) => x && norm(a.textContent).indexOf(x) === 0)) {
					const box = a.closest("[class*='candyrack-ppp-offer-id']");
					if (box && box.style.display !== "none") box.style.display = "none";
				}
			});
	};

	scan();
	let queued = false;
	new MutationObserver(() => {
		if (queued) return;
		queued = true;
		setTimeout(() => {
			queued = false;
			scan();
		}, 120);
	}).observe(document.body, { childList: true, subtree: true });
}

// 360° norāde uz 3D slaida – pazūd pēc pirmā pieskāriena vai 7 sekundēm
function mmqHint360() {
	const slide = document.querySelector(".product-3d-window");
	if (!slide || slide.querySelector(".mmq-hint360")) return;
	const style = document.createElement("style");
	style.textContent =
		".mmq-hint360{position:absolute;bottom:14px;left:50%;transform:translateX(-50%);background:#111;color:#fff;font-size:12px;border-radius:999px;padding:6px 16px;z-index:3;pointer-events:none;white-space:nowrap;opacity:.85;transition:opacity 300ms ease}" +
		".mmq-hint360.is-done{opacity:0}";
	document.head.appendChild(style);
	const hint = document.createElement("div");
	hint.className = "mmq-hint360";
	hint.textContent = MMQ_T.velc;
	slide.appendChild(hint);
	const done = () => {
		hint.classList.add("is-done");
		setTimeout(() => hint.remove(), 400);
	};
	slide.addEventListener("pointerdown", done, { once: true });
	setTimeout(done, 7000);
}

// Papildaprīkojuma kartītē izvēlētā krāsa + novietojuma selekts -> pareizais varianta ID grozam
function mmqAddonVariantSync() {
	document.addEventListener("change", function (ev) {
		const card = ev.target.closest(".addon-product-card");
		if (!card) return;
		const picker = card.querySelector("variant-radios1");
		const json = picker && picker.querySelector('script[type="application/json"]');
		if (!json) return;
		let variants;
		try {
			variants = JSON.parse(json.textContent);
		} catch (e) {
			return;
		}
		const chosen = [];
		picker.querySelectorAll("input[type='radio']:checked").forEach((r) =>
			chosen.push({ any: r.value })
		);
		card.querySelectorAll("select.addon-option-select, input.addon-option-select:checked").forEach((s) =>
			chosen.push({ pos: parseInt(s.dataset.position, 10), val: s.value })
		);
		if (!chosen.length) return;
		const match = variants.find((v) =>
			chosen.every((c) =>
				c.any ? v.options.indexOf(c.any) !== -1 : v.options[c.pos - 1] === c.val
			)
		);
		if (match) {
			const cb = card.querySelector(".addon-checkbox input[type='checkbox']");
			if (cb) cb.value = match.id;
		}
		// stūra maiņa jāparāda arī 3D skatā
		if (ev.target.classList.contains("addon-option-select")) {
			mmqSyncPageState();
			mmqFlush();
		}
	});
}

// Papildaprīkojuma akordeoni un ķekši – deleģēti apstrādātāji, kas pārdzīvo
// sadaļas pārzīmēšanu pēc varianta maiņas
function mmqAddonUi() {
	document.addEventListener("click", function (e) {
		const btn = e.target.closest(".addon-accordion");
		if (!btn) return;
		const panel = btn.nextElementSibling;
		const expanded = btn.getAttribute("aria-expanded") === "true";
		btn.setAttribute("aria-expanded", String(!expanded));
		if (panel) panel.hidden = expanded;
	});
	document.addEventListener("change", function (e) {
		const cb = e.target.closest(".addon-checkbox input[type='checkbox']");
		if (!cb) return;
		const card = cb.closest(".addon-product-card");
		if (card) card.classList.toggle("active", cb.checked);
	});
	const openFirst = () => {
		const first = document.querySelector(".addon-accordion");
		if (first && !first.dataset.autoOpened) {
			first.dataset.autoOpened = "1";
			first.setAttribute("aria-expanded", "true");
			if (first.nextElementSibling) first.nextElementSibling.hidden = false;
		}
	};
	openFirst();
	new MutationObserver(openFirst).observe(document.body, {
		childList: true,
		subtree: true,
	});
}

// Pārlūks mēdz nobīdīt galerijas konteinera scrollLeft (fokuss, enkuri) –
// swiper par to nezina, un visi slaidi vizuāli nobīdās par vienu. Turam nullē.
// Sīktēla klikšķis vienmēr pārslēdz galveno galeriju – swiper thumbs klikšķu
// detektēšana uz skārienekrāniem mēdz nenostrādāt
function mmqThumbClickFallback() {
	const activate = function (e) {
		const thumb = e.target.closest(".js-media-sublist .swiper-slide");
		if (!thumb) return;
		const list = document.querySelector(".js-media-list");
		if (!list || !list.swiper) return;
		const idx = [...thumb.parentElement.children].indexOf(thumb);
		if (idx >= 0 && list.swiper.activeIndex !== idx) list.swiper.slideTo(idx);
	};
	// pointerdown, jo swiper mēdz aprīt pointerup/click; sīktēlu josla nav velkama
	document.addEventListener("pointerdown", activate, true);
	document.addEventListener("click", activate, true);
}

function mmqGuardSliderScroll() {
	// overflow:hidden konteineros scroll notikums nemaz neizšaujas – pārbaudām periodiski
	setInterval(function () {
		document.querySelectorAll(".js-media-list").forEach(function (el) {
			let fixed = false;
			if (el.scrollLeft !== 0) {
				el.scrollLeft = 0;
				fixed = true;
			}
			const sw = el.swiper;
			if (!sw || !sw.wrapperEl) return;
			let tx = 0;
			try {
				tx = new DOMMatrixReadOnly(getComputedStyle(sw.wrapperEl).transform).m41;
			} catch (e) {
				return;
			}
			// ja wrapper transformācija nesakrīt ar swiper stāvokli, saliekam atpakaļ
			if (fixed || Math.abs(tx - sw.translate) > 1) {
				sw.slideTo(sw.activeIndex, 0, false);
				sw.setTranslate(sw.translate);
			}
		});
	}, 600);
}

// Mobilajā 3D slaids sākumā ir paslēpts, un konfigurators izmēru nomēra tieši
// tad – iznāk plats, zems audeklis (piem. 571x250), tāpēc kamera pievelkas
// pārāk tuvu un skatās no augšas. Sekojam slaida izmēram un liekam pārrēķināt,
// tiklīdz tas kļūst redzams vai maina izmēru.
function mmqWatchSlideSize() {
	const slide = document.querySelector(".product-3d-window");
	if (!slide || typeof ResizeObserver === "undefined") return;
	let pending = null;
	// Embeda augstums = slaida platums (kvadrāts kā foto slaidiem), bet TIKAI platos skatos.
	// Mimeeq hidratācijas brīdī nofiksē proporciju no konteinera kastes un pēc tam tikai mēro
	// to pašu attiecību. 02.09. nomērīts uz dzīvās LT lapas: bez piespiešanas audekls sanāca
	// 642x320 (puskvadrāts ar tukšām joslām), ar piespiešanu 642x642 – tieši kā LV (642x642).
	// Mobilajā NEPIESPIEŽAM: tur dzinējs audeklu tur 250 px augstu neatkarīgi no kastes, tāpēc
	// kvadrātiska kaste dod 105 px tukšu joslu, kādas LV nav (LV mobilajā kaste 355x270).
	const PIN_NO = 600;
	const pin = () => {
		const embed = slide.querySelector("mmq-embed");
		const w = Math.round(slide.getBoundingClientRect().width);
		if (!embed || w < 50) return;
		if (w < PIN_NO) {
			// šaurs skats (arī pagriežot telefonu atpakaļ) – atdodam izmērus dzinējam
			if (embed.style.height) embed.style.removeProperty("height");
			if (embed.style.width) embed.style.removeProperty("width");
			return;
		}
		const px = w + "px";
		if (embed.style.width !== px) embed.style.width = px;
		if (embed.style.height !== px) embed.style.height = px;
	};
	pin();
	const nudge = () => {
		pin();
		const canvas = slide.querySelector("canvas");
		if (!canvas) return;
		const box = slide.getBoundingClientRect();
		if (box.width < 50 || box.height < 50) return;
		const cv = canvas.getBoundingClientRect();
		if (Math.abs(cv.height - box.height) < 20 && Math.abs(cv.width - box.width) < 20) return;
		window.dispatchEvent(new Event("resize"));
	};
	const ro = new ResizeObserver(() => {
		pin();
		clearTimeout(pending);
		pending = setTimeout(nudge, 250);
	});
	ro.observe(slide);
}

// Atrod 3D slaida indeksu galerijā. Dažādos šablonos tas NAV vienā vietā
// (Prestige: 1, NUWO GEN2: 2), tāpēc cieto indeksu lietot nedrīkst.
// Skatāmies DOM, ne swiper.slides – tas mēdz būt tukšs, ja swiper
// inicializējies pirms slaidu pievienošanas (MOVE PRO II).
function mmqSlideIndex3d(list) {
	if (!list || !list.swiper) return -1;
	const slides = list.querySelectorAll(".swiper-slide");
	for (let i = 0; i < slides.length; i++) {
		if (slides[i].id === "gallery-3d-window" || slides[i].querySelector("mmq-embed")) return i;
	}
	return -1;
}

// "Skatīt 3D" poga zem galerijas – pārslēdz galveno galeriju uz 3D slaidu.
function mmqGoTo3d() {
	document.querySelectorAll(".product__media-wrapper").forEach((wrap) => {
		if (wrap.offsetParent === null) return; // paslēptais dublikāts
		const list = wrap.querySelector(".js-media-list");
		const idx = mmqSlideIndex3d(list);
		if (list && list.swiper) list.swiper.slideTo(idx >= 0 ? idx : 1);
	});
	const win = document.getElementById("gallery-3d-window");
	if (win) win.scrollIntoView({ behavior: "smooth", block: "center" });
	// slaids tikko kļuva redzams – audeklam jāpārrēķina izmērs
	setTimeout(() => window.dispatchEvent(new Event("resize")), 400);
}

function mmqView3dButton() {
	document.addEventListener("click", function (ev) {
		if (!ev.target.closest(".product__view-3d-button")) return;
		mmqGoTo3d();
	});
}

// Mobilajā 3D logs ir ārpus ekrāna, kad klients ķeksē papildaprīkojumu, tāpēc
// izmaiņa paliek nepamanīta. Aizvedam pie loga un ieslēdzam 3D slaidu.
function mmqAddonScrollTo3d() {
	if (!document.getElementById("gallery-3d-window")) return;
	let last = 0;
	const go = () => {
		if (window.innerWidth >= 990) return; // uz datora logs jau ir redzams
		const now = performance.now();
		if (now - last < 900) return; // viena izvēle var izsaukt vairākus notikumus
		last = now;
		mmqGoTo3d();
	};
	document.addEventListener("change", function (ev) {
		const el = ev.target;
		if (!el.closest || !el.closest(".addon-product-card")) return;
		if (el.matches(".addon-checkbox input[type='checkbox']")) {
			if (el.checked) go();
			return;
		}
		// stūra vai izvietojuma maiņa – tikai tad, ja pats aprīkojums ir izvēlēts
		if (el.matches(".addon-option-select, .mmq-placement input")) {
			const cb = el
				.closest(".addon-product-card")
				.querySelector(".addon-checkbox input[type='checkbox']");
			if (!cb || cb.checked) go();
		}
	});
}

document.addEventListener("DOMContentLoaded", function () {
	mmqView3dButton();
	mmqAddonScrollTo3d();
	mmqWatchSlideSize();
	mmqWatchApp();
	mmqWakeCanvas();
	mmqWatchCartSum();
	mmqHideCandyrackDuplicates();
	mmqHint360();
	mmqAddonVariantSync();
	mmqAddonUi();
	mmqGuardSliderScroll();
	mmqThumbClickFallback();
});

function getSliderSettings() {
	return {
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	};
}

function getSubSliderProductSettings() {
	return {
		slidesPerView: "auto",
		direction: "vertical",
		navigation: false,
	};
}

const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-list") &&
		document.querySelectorAll(".js-media-list").length > 0
	) {
		document.querySelectorAll(".js-media-list").forEach((elem, index) => {
			let slider = new Swiper(elem, {
                a11y: window.sliderA11y,
				slidesPerView: 1,
				spaceBetween: 2,
				autoHeight: true,
				navigation: {
        			nextEl: ".swiper-button-next",
        			prevEl: ".swiper-button-prev",
        		},
				thumbs: {
					swiper: document.querySelectorAll(".js-media-sublist")[index].swiper,
				},
				on: {
					afterInit: function() {
						setTimeout(() => {
							/* Set fixed slider height */
							document.querySelectorAll('.product .product__media-list')[index].style.minHeight = `${document.querySelectorAll('.product .product__media-list')[index].offsetHeight}px`;
						}, 100);
					},
					slideChangeTransitionStart: function () {
						document
							.querySelectorAll(".js-media-sublist")[index]
							.swiper.slideTo(
								document.querySelectorAll(".js-media-list")[index].swiper.activeIndex,
							);
					},
					slideChange: function () {
						window.pauseAllMedia();
						this.params.noSwiping = false;
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							this.slides[this.activeIndex]
								.querySelector(".shopify-model-viewer-ui__button--poster")
								.removeAttribute("hidden");
						}
					},
					touchStart: function (swiper, event) {
						let disableSwipe = false;
						const activeSlide = this.slides[this.activeIndex];

						const modelViewer = activeSlide.querySelector("model-viewer");
						if (modelViewer && !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")) {
							disableSwipe = true;
						}

						// 3D logā vilkšana griež modeli, nevis šķirsta galeriju
						if (event.target.closest('.product-3d-window')) {
							disableSwipe = true;
						}

						this.allowTouchMove = !disableSwipe;
					},
				},
			});

			if (isUpdate) {
				setTimeout(function () {
					slider.update();
				}, 800);
			}
		});
	}
};

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-sublist") &&
		document.querySelectorAll(".js-media-sublist").length > 0
	) {
		document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {
			let subSlider = new Swiper(elem, {
                a11y: window.sliderA11y,
				centeredSlides: false,
				centeredSlidesBounds: false,
				slidesPerView: 5,
				spaceBetween: 8,
                loop: false,
				navigation: {
					nextEl: ".product__button-next",
					prevEl: ".product__button-prev",
				},
				freeMode: false,
				watchSlidesProgress: true,
				on: {
					afterInit: function () {
						this.params.slidesPerView = this.slides && this.slides.length === 2 && window.matchMedia('(min-width: 1200px)').matches ? 2 : 5;

						setTimeout(() => {
							/* Set fixed slider height */
							document.querySelectorAll('.product .product__media-sublist')[index].style.minHeight = `${document.querySelectorAll('.product .product__media-sublist')[index].offsetHeight}px`;
						}, 100);
					},
					touchEnd: function (s, e) {
						let range = 5;
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY);
						if (diff < range || diff > -range) s.allowClick = true;
					},
				},
				transitionStart: function () {
					document
						.querySelector(".js-media-list")
						.swiper.slideTo(
							document.querySelectorAll(".js-media-sublist")[index].swiper.activeIndex,
						);
				},
				breakpoints: {
					749: {
					},
				},
			});

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update();
				}, 800);
			}
		});
	}
};

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open"),
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*",
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus && !elementToFocus.classList.contains('card-focused')) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this)),
		);

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options,
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid,
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");      
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`,
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this)),
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".toggle-scheme-button") === button) return;
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button) return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button"),
			);

			setTimeout(() => {              
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {          
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
            $('header').removeClass('menu-opens')
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`,
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary"),
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.querySelector(".shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom",
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset,
			)}px`,
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
            $('header').addClass("menu-opens");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false),
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		let isOpen = false;

		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		if (!isOpen) {
			document.body.classList.remove("overflow-hidden");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
		}
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this)
		);
		if (this.getAttribute("data-autoplay")) {
			this.loadContent();
		}
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(
					true,
				),
			);

			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();

			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
							this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
		this.currentMMQBlock = null;
		this.currentMMQCode = null;
	}

	onVariantChange(event) {

		const target = event.target;
		if (target && target.dataset) {
			this.currentMMQBlock = target.dataset.mmqBlock || null;
			this.currentMMQCode  = target.dataset.mmqCode || null;
		}

		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.updateVariantStatuses();
		this.updateInventoryQty();
        $('fieldset').each(function () {
          var selected = $(this).find('input[type="radio"]:checked');
          var name = selected.val();
          $(this).find('.name_option').text(name);
        });
		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			if (!this.closest("floated-form")) {
				this.updateMedia();
			}
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateInventoryQty() {
		const inventoryEl = document.getElementById(
			`Inventory-${this.dataset.section}`
		);

		if (!inventoryEl || !this.currentVariant) return;

		if (this.currentVariant.available) {
			inventoryEl.querySelector('span').textContent =
			this.currentVariant.inventory_quantity;
			inventoryEl.classList.remove('visibility-hidden');
		} else {
			inventoryEl.classList.add('visibility-hidden');
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value,
		).concat(
			fieldsets.map((fieldset) => {

				return Array.from(fieldset.querySelectorAll("input")).find(
					(radio) => radio.checked,
				).value;
			})
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				// this.options.sort();
				// variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	updateMedia() {
		// Mimeeq jāatjauno arī tad, ja variantam nav piesaistītas bildes
		mmqMark(this.currentMMQBlock, this.currentMMQCode);
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const swiperWrappers = document.querySelectorAll('.product__media-wrapper');

		swiperWrappers.forEach(elem => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);

				if(!document.querySelector('.mimeeq-product-main, #gallery-3d-window')){
					elem.querySelector(".js-media-list").swiper.slideTo(
						elem.querySelector(".js-media-list").swiper.slides.indexOf(newMedia)
					);
				} else {
					// Mimeeq precei pārslēdzamies uz 3D slaidu, lai izvēle būtu redzama
					const list = elem.querySelector(".js-media-list");
					const idx = mmqSlideIndex3d(list);
					// bez pārbaudes te lidoja izņēmums pie katras varianta maiņas, ja galerijai
					// nav swiper (paslēptais dublikāts) – un tas apturēja pārējo apstrādi
					if (list && list.swiper) list.swiper.slideTo(idx >= 0 ? idx : 1);
					// audekls mēdz piedzimt mazs – liekam pārmērīties pēc pārslēgšanās
					setTimeout(function () { window.dispatchEvent(new Event("resize")); }, 420);
				}
			}
		});
	}

	updateURL() {
		if (!this.classList.contains("featured-product-radios")) {
			if (!this.currentVariant || this.dataset.updateUrl === "false") return;
			window.history.replaceState(
				{},
				"",
				`${this.dataset.url}?variant=${this.currentVariant.id}`,
			);
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1,
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === 'INPUT') {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText = window.variantStrings.unavailable_with_option.replace(
						"[value]",
						input.getAttribute("value"),
					);
				} else if (input.tagName === 'INPUT') {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(
					`price-${this.dataset.section}`,
				);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`,
				);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`,
				);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden"),
					);
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === "",
					);

				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut,
				);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return; 

		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.textContent = window.variantStrings.addToCart;
			mmqUpdateCartSum();
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		const addButton = button?.querySelector('[name="add"]');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`,
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);

		if (!addButton) return;
		this.toggleAddButton(true, window.variantStrings.unavailable);
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);
$('fieldset').each(function () {
  var selected = $(this).find('input[type="radio"]:checked');
  var name = selected.val();
  $(this).find('.name_option').text(name);
});
class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				// input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			/*fieldset.querySelectorAll('input:not(.disabled) + label').forEach(elem => {
				elem.style.opacity = '0.5';
				elem.style.pointerEvents = 'none';
			});*/

			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked,
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class VariantRadios1 extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
		this.currentMainMMQBlock = null;
  		this.currentMainMMQCode = null;
		this.currentMMQBlock = null;
  		this.currentMMQCode = null;
	}

	onVariantChange(event) {
		const target = event.target;
		if (target && target.dataset) {

			// Existing MMQ logic
			this.currentMMQBlock = target.dataset.mmqBlock || null;
			this.currentMMQCode = target.dataset.mmqCode || null;
		}

		const addonCard = target.closest('.addon-product-card');
		if (addonCard) {
			const addonCheckbox = addonCard.querySelector('.addon-checkbox input[type="checkbox"]');
			if (addonCheckbox) {
			addonCheckbox.value = target.dataset.variantId || addonCheckbox.value;
			}
		}

		this.updateMedia();
		}


	updateMedia() {
		mmqMark(this.currentMMQBlock, this.currentMMQCode);
	}
}

customElements.define("variant-radios1", VariantRadios1);

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".addon-checkbox input[type='checkbox']").forEach(function (checkbox) {
    checkbox.addEventListener("change", async function () {
      const blockName = this.dataset.mainMmqBlock || null;
      if (!blockName) return;

	  const swiperWrappers = document.querySelectorAll('.product__media-wrapper');

		swiperWrappers.forEach(elem => {
			const list = elem.querySelector(".js-media-list");
			const idx = mmqSlideIndex3d(list);
			// paslēptajam galerijas dublikātam swiper nav – bez šīs pārbaudes izņēmums
			// nogāza visu apstrādātāju un papildaprīkojums 3D skatā nemaz neparādījās
			if (list && list.swiper) list.swiper.slideTo(idx >= 0 ? idx : 1);
		});
		setTimeout(function () { window.dispatchEvent(new Event("resize")); }, 420);

      mmqMark(blockName, this.checked ? mmqShowCodeForCard(this) : this.dataset.mainMmqCodeHide);

      // atzīmējot papildaprīkojumu, jāpaliek spēkā arī tā izvēlētajai krāsai/pusei
      const card = this.closest('.addon-product-card');
      if (this.checked && card) {
        card.querySelectorAll("input[data-mmq-block]:checked, option[data-mmq-block]:checked").forEach((el) => {
          mmqMark(el.dataset.mmqBlock, el.dataset.mmqCode);
        });
      }
    });
  });
});
